import React, { useState } from 'react';
import { EyeIcon, EyeCloseIcon } from '../icons';
import { Input, InputProps } from '../Input';

const InputPassword: React.FC<InputProps> = ({ ...rest }) => {
    const [showPassword, setShowPassword] = useState<boolean>(false);

    return (
        <Input
            {...rest}
            type={showPassword ? 'text' : 'password'}
            Icon={showPassword ? (
                <EyeIcon onClick={() => setShowPassword(false)} />
            ) : (
                <EyeCloseIcon onClick={() => setShowPassword(true)} />
            )}
        />
    );
};

export { InputPassword };
